import React from "react";
import { TabsContextProvider } from "./TabsContext";
export var Tabs = function Tabs(_ref) {
  var children = _ref.children,
    _ref$manual = _ref.manual,
    manual = _ref$manual === void 0 ? false : _ref$manual,
    _ref$onlyRenderActive = _ref.onlyRenderActiveTabPanelChildren,
    onlyRenderActiveTabPanelChildren = _ref$onlyRenderActive === void 0 ? false : _ref$onlyRenderActive,
    selectedId = _ref.selectedId,
    onChange = _ref.onChange,
    _ref$renderOn = _ref.renderOn,
    renderOn = _ref$renderOn === void 0 ? "work-surface" : _ref$renderOn;
  return /*#__PURE__*/React.createElement(TabsContextProvider, {
    manual: manual,
    onChange: onChange,
    onlyRenderActiveTabPanelChildren: onlyRenderActiveTabPanelChildren,
    renderOn: renderOn,
    selectedId: selectedId
  }, children);
};
//# sourceMappingURL=Tabs.js.map